









import { ExplainScoreCriteriaDetailStepLayoutEnum, OrientationEnum, ScoreCriteriaDetailTypeEnum } from '../../enums';

import ScoreCriteriaDetailStep from './explain-score-criteria-detail-step.component.vue';

enum StepAnimationState {
  CURRENT = 'current',
  PREVIOUS = 'previous',
  NEXT = 'next',
  HIDDEN = 'hidden',
  COLLAPSED = 'collapsed'
}

export default {
  name: 'explain-score-criteria-detail-stepper',
  props: {
    criteriaDetailTypes: {
      type: Array,
      required: true
    },
    currentCriteriaDetailType: String,
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    ScoreCriteriaDetailStep
  },
  computed: {
    indexOfCurrentCriteriaDetailType: function (): number {
      return this.criteriaDetailTypes.indexOf(this.currentCriteriaDetailType);
    }
  },
  methods: {
    getStepAnimationState: function (criteriaDetailType: ScoreCriteriaDetailTypeEnum): StepAnimationState {
      if (!!this.currentCriteriaDetailType) {
        if (criteriaDetailType === this.currentCriteriaDetailType) {
          return StepAnimationState.CURRENT;
        }
        if (criteriaDetailType === this.criteriaDetailTypes[(this.indexOfCurrentCriteriaDetailType - 1)]) {
          return StepAnimationState.PREVIOUS;
        }
        if (criteriaDetailType === this.criteriaDetailTypes[(this.indexOfCurrentCriteriaDetailType + 1)]) {
          return StepAnimationState.NEXT;
        }
        return StepAnimationState.HIDDEN;
      }
      return StepAnimationState.COLLAPSED;
    },
    getStepStyle: function (criteriaDetailType: ScoreCriteriaDetailTypeEnum) {
      const thumbnailStepSize = 200;
      return {
        [StepAnimationState.CURRENT]: () => {
          let marginLeft: string, marginRight: string;
          if (this.indexOfCurrentCriteriaDetailType === 0) {
            marginLeft = `${ thumbnailStepSize }px`;
          }
          if (this.indexOfCurrentCriteriaDetailType === (this.criteriaDetailTypes.length - 1)) {
            marginRight = `${ thumbnailStepSize }px`;
          }
          return {
            height: '100%',
            width: `calc(100% - ${ (thumbnailStepSize * 2) }px)`,
            marginLeft,
            marginRight
          };
        },
        [StepAnimationState.PREVIOUS]: () => ({
          height: `${ thumbnailStepSize }px`,
          width: `${ thumbnailStepSize }px`
        }),
        [StepAnimationState.NEXT]: () => ({
          height: `${ thumbnailStepSize }px`,
          width: `${ thumbnailStepSize }px`,
          opacity: 0
        }),
        [StepAnimationState.HIDDEN]: () => ({
          height: 0,
          width: 0,
          opacity: 0
        }),
        [StepAnimationState.COLLAPSED]: () => ({
          height: '100%',
          width: `${ (100 / this.criteriaDetailTypes.length) }%`
        })
      }[this.getStepAnimationState(criteriaDetailType)]();
    },
    getStepProps: function (criteriaDetailType: ScoreCriteriaDetailTypeEnum) {
      const stepAnimationState = this.getStepAnimationState(criteriaDetailType);

      let orientation: OrientationEnum;
      if (stepAnimationState !== StepAnimationState.COLLAPSED) {
        orientation = {
          [ScoreCriteriaDetailTypeEnum.CATALOG_DEFINITION]: OrientationEnum.LEFT,
          [ScoreCriteriaDetailTypeEnum.BUSINESS_RULES]: OrientationEnum.LEFT,
          [ScoreCriteriaDetailTypeEnum.QUERY_CONTEXT]: OrientationEnum.LEFT, // TODO: fix top orientation
          [ScoreCriteriaDetailTypeEnum.USER_CONTEXT]: OrientationEnum.LEFT,
          [ScoreCriteriaDetailTypeEnum.CUSTOM_SCORE]: OrientationEnum.LEFT
        }[criteriaDetailType];
      } else {
        orientation = OrientationEnum.TOP;
      }

      const layout: ExplainScoreCriteriaDetailStepLayoutEnum = {
        [StepAnimationState.CURRENT]: ExplainScoreCriteriaDetailStepLayoutEnum.EXPANDED,
        [StepAnimationState.PREVIOUS]: ExplainScoreCriteriaDetailStepLayoutEnum.THUMBNAIL,
        [StepAnimationState.NEXT]: ExplainScoreCriteriaDetailStepLayoutEnum.THUMBNAIL,
        [StepAnimationState.HIDDEN]: ExplainScoreCriteriaDetailStepLayoutEnum.THUMBNAIL,
        [StepAnimationState.COLLAPSED]: ExplainScoreCriteriaDetailStepLayoutEnum.COLLAPSED
      }[stepAnimationState];

      return {
        criteriaDetailType,
        orientation,
        layout,
        messages: this.messages
      };
    }
  }
};
